import React, { useEffect, useState } from "react";
import Accordion from "../../components/Accordian";
import IMG from "../../assets/images/faq/faq.png";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [faqData, setFaqData] = useState([]);
  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
    if (searchQuery === "") {
      axios
        .get(process.env.REACT_APP_BACKEND + "needhelp/getfaqs")
        .then((resp) => {
          setFaqData(resp.data.data);
        })
        .catch((err) => console.log(err));
    } else {
      setFaqData(
        faqData.filter((faq) =>
          faq.question.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }
  }, [searchQuery]);

  return (
    <div className="container py-5" style={{ width: "auto" }}>
      <h1 className="t-center">Frequently Asked questions</h1>
      <p className="t-center mt-1" style={{ color: "var(--grey-color)" }}>
        Quick answers to common queries about our services
      </p>
      <div className="row mt-5">
        <div className="col-lg-8 col-md-8 col-sm-12 ">
          <div className="bxShadow p-3" style={{ borderRadius: "6px" }}>
            <div
              className=" mb-4 d-flex align-items-center justify-content-between"
              style={{
                borderRadius: "8px",
                border: "2px solid var(--primary-color)",
              }}
            >
              <input
                type="text"
                placeholder="Search FAQs"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  border: "none",
                  padding: "10px",
                  width: "80%",
                  borderRadius: "6px",
                  outline: "none",
                }}
              />
              <SearchIcon style={{ padding: "0 30px" }} />
            </div>
            {faqData.map((fq, index) => (
              <Accordion
                key={index}
                title={fq?.question}
                isOpen={openIndex === index}
                onToggle={() => handleToggle(index)}
              >
                <div dangerouslySetInnerHTML={{ __html: fq?.answer }} />
              </Accordion>
            ))}
          </div>
        </div>
        <div className="col-lg-4 col-md-4 ">
          <div
            className="bxShadow pb-3"
            style={{
              borderRadius: "6px",
            }}
          >
            <img src={IMG} className="w100" alt="faq" />
            <h2 className="px-3 mt-3">Still need Help?</h2>
            <div className="px-3 py-2">
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <EmailIcon style={{ color: "var(--primary-color)" }} />
                <p style={{ margin: 0 }}>support@sevenlytravel.com</p>
              </div>
              <div
                className="mt-2"
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <PhoneIcon style={{ color: "var(--primary-color)" }} />
                <p style={{ margin: 0 }}>(866) 760-5088</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
